

import Vue from 'vue';
import Router, { Route } from 'vue-router';
import Home from './views/Home.vue';
import Dashboard from './views/Dashboard.vue';
import Alerts from './views/Alerts.vue';
import Settings from './views/Settings.vue';
import Admin from './views/Admin.vue';
import MySettings from './components/MySettings.vue';
import CallReports from './views/CallReports.vue';
import Reports from './views/Reporting.vue';
import VoiceMails from './views/VoiceMails.vue';
import TextingPanel from './components/TextingPanel/text_panelcomponent.vue'

import Logout from './views/Logout.vue';
import ContactsInfo from './views/Contacts.vue';
import ContactsInfo_sp2 from './views/Contacts_sp2.vue';
import expressfuneral from './components/customreports/expressfuneral.vue';
import contactmsghistory from './components/Contact_sprint2/contactmsghistory.vue';
import childrout   from './Child_routing.vue'; 
import Conference from './views/Conference.vue';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import { store, AppSettings } from './store';    


Vue.use(Router);

const isLoggedIn123 = async (to: Route, from: Route, next: Function) => {
  try {
    if (to.meta.auth) {
      next({ name: 'dashboard' });
    } else {
      next();
    }
  } catch (err) {
    next({ name: 'login' });
  }
};

const isLoggedInAndAdmin = async (to: Route, from: Route, next: Function) => {
  const idToken = store.state.account.jwt;
     axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.account.jwt;
      try {
          const response = await axios.get(`${AppSettings.API_HOST}verifyJWT`);
          if (!idToken) {
              next({name: 'login'});
          } else {
              axios.get(`${AppSettings.API_HOST}privilege`)
          .then((r) => {
                  const privilege_level=r.data;
                  if(privilege_level==='voitress-admin' || privilege_level === 'admin')
                  {
                      next();
                  }
                  else
                  {
                      next({name: 'dashboard'});
                  }
          });;
            
          }
      } catch (err) {
          console.error(err);
          next({ name: 'login' });
      }
  
 
     
};  
const isLoggedIn = async (to: Route, from: Route, next: Function) => {
  next();
  //\return true;
  //console.log('df', to, from)
  const idToken = store.state.account.jwt;
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.account.jwt;
  try {
    const response = await axios.get(`${AppSettings.API_HOST}verifyJWT`);
    if (!idToken) {
      next({ name: 'login' });
    } else {
      store.commit("CONTACT_SIDEBARSTATSU", "personal");
      next();
    }
  } catch (err) {
    console.error(err);
    next({ name: 'login' });
  }
};

export default new Router({
  
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Home

    },
    {
      path: '/',
      component: childrout,
      children:[
        {
          path: '/dashboard',
          name: 'dashboard',
          component: Dashboard,
          beforeEnter: isLoggedIn
        },
        {
          path: '/MySettings',
          name: 'MySettings',
          component: MySettings,
          beforeEnter: isLoggedIn
        },
        {
          path: '/alerts',
          name: 'alerts',
          component: Alerts,
          beforeEnter: isLoggedIn
        },
        {
          path: '/admin',
          name: 'admin',
          component: Admin,
          beforeEnter: isLoggedInAndAdmin
        },
        {
          path: '/voicemails',
          name: 'voicemails',
          component: VoiceMails,
          beforeEnter: isLoggedIn
        },
        {
          path: '/settings',
          name: 'settings',
          component: Settings,
          beforeEnter: isLoggedIn
        },
        // {
        //   path: '/reporting',
        //   name: 'reporting',
        //   component:CallReports,// Reporting,
        //   beforeEnter: isLoggedIn
        // },
        {
          path: '/reports', 
          name: 'reports',
          component:Reports,// Reporting,
          beforeEnter: isLoggedIn
        },
        {
          path: '/customreports/expressfuneral', 
          name: 'expressfuneral',
          component:expressfuneral,// Reporting,
          beforeEnter: isLoggedIn
        },
        {
          path: '/logout',
          name: 'logout',
          component: Logout,
        },
        {
          path: '/contactsinfo',
          name: 'contactsinfo',
          component: ContactsInfo,
          beforeEnter: isLoggedIn,
        },
        {
          path: '/ContactsInfo_sp2',
          name: 'ContactsInfo_sp2',
          component: ContactsInfo_sp2,
          beforeEnter: isLoggedIn
        },
        {
          path: '/TextingPanel',
          name: 'TextingPanel',
          component:TextingPanel,
          beforeEnter: isLoggedIn
        },
        // {
        //   path: '/C',
        //   name: 'Customreports',
        //   component: customreports,
        //   beforeEnter: isLoggedIn
        // },
        {
          path: '/conference',
          name: 'conference',
          component: Conference,
          beforeEnter: isLoggedIn
        },
        {
          path: '*',
          name: 'catch-all',
          redirect: '/login',
          beforeEnter: isLoggedIn123
        },
      ]
    },

  
    
  ],
  mode: 'history',
});
